export default __webpack_public_path__ + "static/media/partner.f0a695b5.svg";